import { saveToStorage, loadFromStorage } from '@/util/saveStore'

const VIDEO_HISTORY_KEY = 'focus_video'
const saveFocusVideo = function(video) {
  const videoHistory = loadFromStorage(VIDEO_HISTORY_KEY, [])
  insertFocusArray(videoHistory, video)
  saveToStorage(VIDEO_HISTORY_KEY, videoHistory)
}
function insertFocusArray(arr, item) {
  arr.push(item)
}
const loadFocusVideoHitory = function() {
    return loadFromStorage(VIDEO_HISTORY_KEY,[])
}
export { saveFocusVideo,loadFocusVideoHitory }
